export default __webpack_public_path__ + "static/media/hht1_ani_20.892e61e7.png";